import { render } from "./TablaProveedores.vue?vue&type=template&id=432626c1&scoped=true"
import script from "./TablaProveedores.vue?vue&type=script&lang=js"
export * from "./TablaProveedores.vue?vue&type=script&lang=js"

import "./TablaProveedores.vue?vue&type=style&index=0&id=432626c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432626c1"]])

export default __exports__